import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function RecruitHeroSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section className="relative h-[420px] md:h-[520px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat pointer-events-none"
        style={{
          backgroundImage:
            "url('/images/recruit-kv.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-navy/50 via-navy/60 to-navy/80 pointer-events-none" />
      <div
        ref={ref}
        className={`relative z-10 h-full flex items-center justify-center transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center px-4">
          <span className="text-gold text-sm tracking-[4px] font-bold block mb-3">RECRUIT</span>
          <h1 className="text-4xl md:text-5xl font-black text-white">採用情報 / recruit</h1>
          <p className="text-gray-300 mt-4 text-lg">やりがいと収入、両方を実現する警備会社</p>
        </div>
      </div>
    </section>
  );
}